import { Component, EventEmitter, Output } from '@angular/core';

/**
 * component to launch scope is shown,
 * when the whole legacy workflow has been done.
 * that means the user has been connected and has downloaded and installed runtime
 */
@Component( {
    selector: 'app-launch-scope',
    templateUrl: './launch-scope.component.html',
    styleUrls: ['./launch-scope.component.scss'],
    standalone: false
} )
export class LaunchScopeComponent {
    /** handle click on launch button {@link SharedService} */
    @Output() doLaunchScope = new EventEmitter();
}
